/*
 * App Messages
 *
 * This contains all the text for the App component.
 */
import { defineMessages } from '@/components/formatted_message/FormattedMessage';

export const Root = defineMessages({
  title: {
    id: 'app.containers.Root.title',
  },
});
